var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c(
        "callout",
        {
          attrs: {
            "border-color": _vm.getStatusColor(_vm.value.statusId),
            controlled: true,
            opened: _vm.calloutOpened
          },
          on: { "click:open": _vm.getDetails },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _vm.calloutMode === _vm.CALLOUT_MODES.ASSIGN_SPECIALIST
                    ? [
                        _c("assign-specialist", {
                          attrs: {
                            dispose: () => {
                              _vm.calloutMode =
                                _vm.CALLOUT_MODES.STUDENT_INFORMATION
                              _vm.calloutOpened = false
                            },
                            save: _vm.saveAssignment,
                            "selected-specialist-id":
                              _vm.value.assignmentSpecialistId,
                            specialists: _vm.assignSpecialists
                          }
                        })
                      ]
                    : _vm.calloutMode === _vm.CALLOUT_MODES.CONFIRM_ADMISSION
                    ? [
                        _c("confirm-admission", {
                          attrs: {
                            "admission-info": _vm.admissionInfo,
                            dispose: () => {
                              _vm.calloutMode =
                                _vm.CALLOUT_MODES.STUDENT_INFORMATION
                              _vm.calloutOpened = false
                            },
                            "has-pilot-permission": _vm.hasPilotPermission,
                            save: _vm.saveConfirm,
                            update: _vm.updateConfirm
                          },
                          model: {
                            value: _vm.value,
                            callback: function($$v) {
                              _vm.value = $$v
                            },
                            expression: "value"
                          }
                        })
                      ]
                    : _vm.calloutMode === _vm.CALLOUT_MODES.VISIT_ABSENCE
                    ? [
                        _c("visit-absence", {
                          attrs: {
                            data: _vm.absence,
                            dispose: () => {
                              _vm.calloutMode =
                                _vm.CALLOUT_MODES.STUDENT_INFORMATION
                              _vm.calloutOpened = false
                            }
                          },
                          on: { save: _vm.saveAdsence }
                        })
                      ]
                    : _vm.calloutMode === _vm.CALLOUT_MODES.DENY_BY_PROVIDER
                    ? [
                        _c("DenyByProvider", {
                          attrs: { item: _vm.value },
                          on: {
                            finished: () => {
                              _vm.calloutMode =
                                _vm.CALLOUT_MODES.STUDENT_INFORMATION
                              _vm.calloutOpened = false
                            },
                            refresh: () => {
                              _vm.$emit("refreshReferralGrid")
                            }
                          }
                        })
                      ]
                    : _vm.calloutMode ===
                        _vm.CALLOUT_MODES.STUDENT_INFORMATION ||
                      _vm.calloutMode ===
                        _vm.CALLOUT_MODES.SERVICE_OFFERING_CURRENTYEAR ||
                      _vm.calloutMode === _vm.CALLOUT_MODES.DIAGNOSIS
                    ? [
                        _c(
                          "b-card",
                          {
                            staticClass: "bg-transparent border-0 p-2",
                            attrs: { "no-body": "" }
                          },
                          [
                            _c(
                              "b-card",
                              {
                                staticClass: "bg-white border-0 p-3",
                                attrs: { "no-body": "" }
                              },
                              [
                                _c(
                                  "b-tabs",
                                  {
                                    staticClass: "mipe-green-tabs",
                                    attrs: {
                                      "content-class": "pt-4",
                                      "no-nav-style": ""
                                    },
                                    model: {
                                      value: _vm.tabsModel,
                                      callback: function($$v) {
                                        _vm.tabsModel = $$v
                                      },
                                      expression: "tabsModel"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-tab",
                                      {
                                        attrs: {
                                          active: "",
                                          title: "Información General"
                                        }
                                      },
                                      [
                                        _c("InformationDetail", {
                                          attrs: {
                                            "has-pilot-permission":
                                              _vm.hasPilotPermission,
                                            value: _vm.value
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm.canAddDiagnosisInPilot
                                      ? _c(
                                          "b-tab",
                                          {
                                            attrs: {
                                              active: _vm.tabsModel === 1,
                                              lazy: "",
                                              title: "Diagnóstico"
                                            },
                                            on: { click: _vm.addDiagnosis }
                                          },
                                          [
                                            _c("add-diagnosis", {
                                              attrs: { item: _vm.value },
                                              on: {
                                                cancel: _vm.onDiagnosisCancel
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "b-tab",
                                      {
                                        attrs: {
                                          lazy: "",
                                          title: "Intervenciones Adeudadas"
                                        }
                                      },
                                      [
                                        _c("InterventionsDue", {
                                          attrs: {
                                            "academic-year-id":
                                              _vm.value.academicYearId,
                                            "discipline-name":
                                              _vm.value.disciplineName,
                                            "discipline-type-id":
                                              _vm.value.disciplineTypeId,
                                            "referral-number":
                                              _vm.value.referralNumber,
                                            "service-specialist-name":
                                              _vm.value.serviceSpecialist,
                                            "student-name": _vm.value.fullName,
                                            "student-sie-id":
                                              _vm.value.studentSieId
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-tab",
                                      {
                                        attrs: {
                                          active: _vm.tabsModel === 3,
                                          lazy: "",
                                          title:
                                            "Ofrecimiento de Servicios Año Actual"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.serviceOfferingCurrentYear(
                                              _vm.value
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("ServiceOfferingCurrentYear", {
                                          attrs: {
                                            data: _vm.value.serviceOfferingData,
                                            dispose: () => {
                                              _vm.calloutMode =
                                                _vm.CALLOUT_MODES.SERVICE_OFFERING_CURRENTYEAR
                                              _vm.calloutOpened = false
                                            }
                                          },
                                          on: {
                                            print: function($event) {
                                              return _vm.onPrint(_vm.value)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "row p-3" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-md-2 border-right col-balloon" },
              [
                _c(
                  "div",
                  { staticClass: "col-sm mb-4" },
                  [
                    _c("balloon", {
                      staticClass: "mt-2 font-15",
                      attrs: {
                        bg: `border-none text-center bg-${_vm.getStatusColor(
                          _vm.value.statusId
                        )}`,
                        dot: "",
                        text: _vm.value.status
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col ml-sm-none" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.value.referralNumber))])
                  ])
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col font-weight-normal ml-sm-none" },
                    [_c("p", [_vm._v(_vm._s(_vm.value.disciplineName))])]
                  )
                ]),
                _vm.value.daysCount
                  ? _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col font-weight-normal ml-sm-none" },
                        [
                          _c("p", [
                            _vm._v(" Días de Vencimiento: "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "rounded-pill bg-primary-17 text-white p-1"
                              },
                              [_vm._v(" " + _vm._s(_vm.value.daysCount) + " ")]
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e()
              ]
            ),
            _c("div", { staticClass: "col-sm" }, [
              _c("div", { staticClass: "row mb-2" }, [
                _c("div", { staticClass: "col-sm-12 col-md-5" }, [
                  _c("span", { staticClass: "data-label" }, [
                    _vm._v("Estudiante:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          `${(_vm.value.fullName || "").replace(
                            /[0-9]/g,
                            ""
                          )} - ${_vm.value.studentSieId}`
                        ) +
                        " "
                    )
                  ])
                ]),
                _c("div", { staticClass: "col-sm" }, [
                  _c("span", { staticClass: "data-label" }, [_vm._v("Edad:")]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(_vm._s(_vm.value.studentAgeFormatted) + " años")
                  ])
                ]),
                _vm.userHasPermissions("provider.referral.center.change")
                  ? _c(
                      "div",
                      { staticClass: "col-sm" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      attrs: {
                                        clearable: false,
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        label: "CSEE:",
                                        options: _vm.centers,
                                        placeholder: "Seleccione"
                                      },
                                      on: { input: _vm.onChangeCenterHandler },
                                      model: {
                                        value: _vm.csee,
                                        callback: function($$v) {
                                          _vm.csee = $$v
                                        },
                                        expression: "csee"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3742838487
                          )
                        })
                      ],
                      1
                    )
                  : _c("div", { staticClass: "col-sm" }, [
                      _c("span", { staticClass: "data-label" }, [
                        _vm._v("CSEE:")
                      ]),
                      _c("p", { staticClass: "data" }, [
                        _vm._v(
                          " " + _vm._s((_vm.csee || { name: "-" }).name) + " "
                        )
                      ])
                    ])
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-12 col-md-5" }, [
                  _c("span", { staticClass: "data-label" }, [
                    _vm._v("Modalidad:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(" " + _vm._s(_vm.value.modalityTypeName) + " ")
                  ])
                ]),
                _c("div", { staticClass: "col-sm" }, [
                  _c("span", { staticClass: "data-label" }, [
                    _vm._v("Frecuencia:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(" " + _vm._s(_vm.value.frequecy) + " ")
                  ])
                ]),
                _c("div", { staticClass: "col-sm" }, [
                  _c("span", { staticClass: "data-label" }, [
                    _vm._v("Duración:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(" " + _vm._s(_vm.value.duration) + " ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-12 col-md-5" }, [
                  _c("span", { staticClass: "data-label" }, [
                    _vm._v("Nota de Admisión:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(
                      " " + _vm._s(this.hasAdmissionNote ? "Sí" : "No") + " "
                    )
                  ])
                ]),
                _c("div", { staticClass: "col-sm" }, [
                  _c("span", { staticClass: "data-label" }, [
                    _vm._v("Servicio Coordinado:")
                  ]),
                  _c("p", { staticClass: "data" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.value.coordinatedService ? "Sí" : "No") +
                        " "
                    )
                  ])
                ])
              ])
            ]),
            _c(
              "div",
              {
                staticClass:
                  "col-sm-12 col-md-2 mr-3 d-flex flex-column align-items-md-end align-items-sm-start justify-content-md-start"
              },
              [
                _c("DropDown", {
                  staticClass: "responsive-dropdown",
                  attrs: { items: _vm.getMenuAvailableItems }
                }),
                _vm.showAdmissionAbsenseCount
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center mt-0 mt-md-4 mt-sm-0 pt-5"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "font-weight-normal font-14 color-secondary-6 pr-1"
                          },
                          [_vm._v(" Ausencia (s) de Admisión: ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass:
                              "font-weight-normal font-16 color-primary-2"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.value.admissionAbsenceCount) +
                                " "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.showInterventionPlanAbsenseCount
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center mt-0 mt-md-4 mt-sm-0 pt-5"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "font-weight-normal font-14 color-secondary-6 pr-1"
                          },
                          [_vm._v(" Ausencia de Plan: ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass:
                              "font-weight-normal font-16 color-primary-2"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.value.interventionPlanAbsenceCount) +
                                " "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }